import { IAgreementListFilterRaw } from 'APIPackage/AgreementListModule/interfaces/IAgreementListFilterRaw';
import { IAgreementListFilterParams } from 'APIPackage/AgreementListModule/interfaces/IAgreementListFilterParams';
import { getStorageItem } from 'CorePackage/MainModule/common/localStore';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { getRawFilter } from './getRawFilter';
import { getAgreementListSearchValue } from '../selectors/agreementListSelectors';

export const getRequestFilterData = (
  state: IRootState,
  filter?: IAgreementListFilterParams,
): IAgreementListFilterParams | null => {
  const isFilterOn = !!getStorageItem(StorageNamesEnum.AGREEMENT_LIST_FILTER_ON);

  if (filter) {
    return (isFilterOn && filter) || null;
  }
  const rawFilter: IAgreementListFilterRaw = getRawFilter();
  const searchValue = getAgreementListSearchValue(state);

  if (!rawFilter) {
    return null;
  }

  let requestData: IAgreementListFilterParams | null = null;

  if (isFilterOn) {
    requestData = searchValue ? { ...rawFilter, searchString: searchValue } : { ...rawFilter };
  } else {
    requestData = searchValue ? { searchString: searchValue } : {};
  }

  return requestData;
};
